module.exports = __webpack_public_path__ + "static/media/20180524-LCS-004-3.d5ae07e7.jpg";